<template>
  <div class="space-y-4">
    <div v-for="(segment, idx) in state.segments" :key="idx">
      <p
        v-if="idx === flights[0].segments.length"
        class="text-text-neutral-primary text-base font-bold"
      >
        {{ t('ancillaries.flightDelay.form.flightFrom') }} ←
      </p>
      <div class="flex w-full items-center justify-between">
        <p class="text-text-neutral-primary text-sm font-medium">
          {{ segment.dep.city }} - {{ segment.arr.city }}
        </p>
        <button
          type="button"
          :disabled="isActualizing"
          class="text-sm font-semibold transition duration-150"
          :class="
            isSomeUnSelected(segment) || isActualizing
              ? 'text-text-neutral-secondary/20'
              : 'text-text-positive-primary'
          "
          @click="flightDelayStore.resetSegmentAllPassengers(segment.idx)"
        >
          {{ t('products.packages.reset') }}
        </button>
      </div>
      <div class="mt-3 flex flex-col gap-3">
        <FlightDelayPassengerCheckbox
          v-for="passenger in segment.passengers"
          :key="passenger.idx"
          :passenger="passenger"
          :price="state.pricing.perPassenger"
          :is-loading="isActualizing"
          @onUpdateIsSelected="
            val =>
              flightDelayStore.updatePassengerSelection(
                segment.idx,
                passenger.idx,
                val,
              )
          "
          @onShowAlert="showPassengerAlert"
        />
      </div>
    </div>
    <FreeAlert
      ref="passengerAlertRef"
      class="fixed inset-x-0 top-10 z-30 mx-auto w-fit"
      :duration="3000"
    >
      <template #icon>
        <img
          src="@/assets/images/red-warning.svg"
          width="24"
          height="24"
          alt=""
        />
      </template>
      <p class="text-text-neutral-primary whitespace-pre-wrap text-center">
        {{ $t('ancillaries.flightDelay.alert') }}
      </p>
    </FreeAlert>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { FreeAlert, type flightEntity } from 'freedom-shared';
  import { ref } from 'vue';
  import { storeToRefs } from 'pinia';

  import type { SegmentWithPassengers } from '../types';
  import FlightDelayPassengerCheckbox from './FlightDelayPassengerCheckbox.vue';
  import { useFlightDelayStore } from '../model';

  defineProps<{
    flights: flightEntity.types.MappedFlight[];
  }>();

  const flightDelayStore = useFlightDelayStore();
  const { state, isActualizing } = storeToRefs(flightDelayStore);

  const { t } = useI18n();

  const passengerAlertRef = ref<InstanceType<typeof FreeAlert>>();

  const isSomeUnSelected = (segment: SegmentWithPassengers) =>
    segment.passengers?.every(passenger => !passenger.isSelected);

  const showPassengerAlert = () => {
    passengerAlertRef.value?.show();
  };
</script>
